// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1SgOV","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__X59je"};